import { SubAPI } from "./SubAPI";
export class ProjectLog extends SubAPI {
    list(input) { return this.fetcher.get("/api/project-log/list", input); }
}
